<div class="container dashboard_card fm_padding dc_fixed" id="contactPopupCard" *ngIf="showContactPopup">

    <div class="dc_header">
        <span></span>
        <h3>Customer Details</h3>
        <button (click)="CloseAddContact()"><i class="icon-close"></i></button>
    </div>

    <div class="popup_inner">

        <!-- <h3 class="sub_title">CUSTOMER DETAILS</h3> -->
        <ng-container *ngFor="let obj of this.contacts1; let cg = index;">

        <div class="pwb_div_line"></div>

        <h3 class="asc_sub_title">CONTACT {{cg + 1}} <span *ngIf="cg!=0" class="ast_remove_btn"><a href="javascript:void(0)" (click)="Call_remove_contacts(cg)" class="btn"><i class="icon-close"></i></a></span></h3>
        <div class="ppuc_tbox_grid">

            <div class="lcta_tbox"  id="divaddContact{{cg}}Title">

                <span>Title</span>

                <div class="lct_slt">

                    <select  [(ngModel)]=obj.contactTitle.value  (click)="obj.contactTitle.iserr=false">

                        <option value="0">Select Title</option>
                        <ng-container *ngFor="let obj of  this.state.contactTitleList">

                            <option value="{{obj.child_tag_id}}">{{obj.child_tag_name}}</option>

                        </ng-container>

                    </select>

                </div>



            </div>

            <div class="lcta_tbox" [ngClass]="{'error': obj.contactName.iserr}" id="divaddContact{{cg}}Name">

                <span>Name<span>*</span></span>

                <input type="text" class="tbox "name="contact{{cg}}Name" id="txtaddcontact{{cg}}Name"
                placeholder="Type your contact name" [(ngModel)]="obj.contactName.value"
                on-focus="obj.contactName.iserr=false">

                <span class="error_txt">{{obj.contactName.err_txt}}</span>

            </div>

            <div class="lcta_tbox"  [ngClass]="{'error': obj.contactDesignation.iserr}" id="divaddContact{{cg}}Designation">

                <span>Profession<span>*</span></span>

                <div class="lct_slt">

                    <select  [(ngModel)]=obj.contactDesignation.value  id="drpcontact{{cg}}Designation" (click)="obj.contactDesignation.iserr=false" (ngModelChange)="obj.contactSpeciality.value=0">

                        <option value="0">Select Profession</option>
                        <ng-container *ngFor="let obj of  this.state.contactDesignationList">

                            <option value="{{obj.child_tag_id}}">{{obj.child_tag_name}}</option>

                        </ng-container>

                    </select>

                </div>

                <span class="error_txt">{{obj.contactDesignation.err_txt}}</span>

            </div>

            <div class="lcta_tbox" *ngIf="this.state.featureSettingsisContactDetail" [ngClass]="{'error': obj.contactSpeciality.iserr}"  id="divaddcontact{{cg}}Speciality">

                <span>Detail<span>*</span></span>

                <div class="lct_slt">

                    <select  [(ngModel)]=obj.contactSpeciality.value [disabled]="obj.contactDesignation.value==0" id="drpcontact{{cg}}Speciality" (click)="obj.contactSpeciality.iserr=false">

                        <option value="0">Select Detail</option>
                        <ng-container *ngFor="let obj1 of  this.state.contactSpecialityList">
                            <ng-container *ngIf="obj1.code == obj.contactDesignation.value">
                                <option value="{{obj1.child_tag_id}}">{{obj1.child_tag_name}}</option>
                            </ng-container>
                        </ng-container>

                    </select>

                </div>

                <span class="error_txt">{{obj.contactSpeciality.err_txt}}</span>

            </div>

            <div class="lcta_tbox" [ngClass]="{'error': obj.contactMobileNo.iserr}" id="divaddContact{{cg}}Mobile">

                <span>Mobile<span></span></span>

                <input type="text" class="tbox "name="contact{{cg}}Mobile" id="txtaddcontact{{cg}}Mobile"
                placeholder="Type your contact mobile" [(ngModel)]="obj.contactMobileNo.value"
                [cMaxLength]="'10'"
                on-focus="obj.contactMobileNo.iserr=false"
                (paste)="onPaste($event)" (input)="onInput('txtaddcontact',cg,'Mobile')"
                (keypress)="numberOnly($event)">

                <span class="error_txt">{{obj.contactMobileNo.err_txt}}</span>

            </div>

            <div class="lcta_tbox" [ngClass]="{'error': obj.contactEmail.iserr}" id="divtxtaddcontact{{cg}}Email">

                <span>Email ID</span>

                <input type="text" class="tbox "name="contact{{cg}}Email" id="txtaddcontact{{cg}}Email"
                placeholder="Type your contact email ID" [(ngModel)]="obj.contactEmail.value"
                on-focus="obj.contactEmail.iserr=false">

                <span class="error_txt">{{obj.contactEmail.err_txt}}</span>

            </div>

        </div>
        </ng-container>

        <div class="lcta_ab_card">

            <button (click)="AddContacts()"><i class="icon-screen_plus"></i> Add More</button>

        </div>

    </div>

    <button class="fixed_btn" (click)="Submit_AddContact()">Submit</button>

</div>

<div class="popupu_card ci_popup_card" id="confirmdeletecontact">

    <div class="popup_inner">

        <a href="javascript:void(0)" (click)="confirmCloseAddContactdelete()" class="pc_close_btn"><i class="icon-close"></i></a>

        <div class="ci_popup_txt_area">

            <h3>Confirm Delete</h3>

            <h6>Are you sure want to delete?</h6>

        </div>

        <div class="ci_popup_btn_area">

            <button (click)="confirmdelete_cancel()">CANCEL</button>

            <button (click)="confirmdelete_yes()">DELETE</button>

        </div>

    </div>

</div>
